module.exports = __webpack_public_path__ + "8d53f199737f9468ce3f0d9ffbc09b6c.png";


//////////////////
// WEBPACK FOOTER
// ./bower_components/angular-tree-control/images/folder.png
// module id = 759
// module chunks = 0